import { H2RButton, H2RInput } from "../../imports";
import { H2RCheckbox } from "../../imports";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { TextArea } from "../FormElements";

const placeholderCss = `body { background-color: rgba(0, 0, 0, 0); }`

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Name"
				value={cue.name}
				placeholder="My website"
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>
			<H2RInput
				label="URL"
				value={cue.url}
				placeholder="https://heretorecord.com"
				onChange={(value) => {
					onUpdate({ url: value });
				}}
			/>
			<H2RCheckbox
				label="Webpage interactable"
				hint={cue.interactable && "Disable to 'Save PNG'"}
				checkboxLabel={cue.interactable ? "Interaction on" : "Interaction off"}
				checked={cue.interactable || false}
				onChange={(change) => {
					onUpdate({ interactable: change });
				}}
			/>
			<H2RButton
				text="Refresh website"
				size="small"
				icon={faRefresh}
				colour="dark"
				onClick={()=>{
					onUpdate({refreshCount: new Date().getTime()})
				}}
				/>
				{/* <TextArea
				label="Custom CSS"
				placeholder={placeholderCss}
				onChange={(change)=>{
					onUpdate({customCss: change})
				}}
				/> */}
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.name || "Website"}</span>
		</div>
	);
};
